"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = exports.MultiSelectContext = void 0;
var react_1 = __importStar(require("react"));
var INITIAL_VALUE = {
    selection: [],
    select: function () { },
    deselect: function () { },
    isWrapped: false,
};
exports.MultiSelectContext = (0, react_1.createContext)(INITIAL_VALUE);
var MultiSelect = function (_a) {
    var children = _a.children, onChange = _a.onChange;
    var _b = __read((0, react_1.useState)([]), 2), selection = _b[0], setSelection = _b[1];
    var select = function (id, payload) {
        if (payload === void 0) { payload = {}; }
        setSelection(function (prev) {
            var next = prev.find(function (item) { return item.id === id; })
                ? prev
                : __spreadArray(__spreadArray([], __read(prev), false), [{ id: id, payload: payload }], false);
            onChange &&
                JSON.stringify(next) !== JSON.stringify(prev) &&
                onChange(next, payload);
            return next;
        });
    };
    var deselect = function (id, payload) {
        if (payload === void 0) { payload = {}; }
        setSelection(function (prev) {
            var next = prev.filter(function (x) { return x.id !== id; });
            onChange && onChange(next, payload);
            return next;
        });
    };
    return (react_1.default.createElement(exports.MultiSelectContext.Provider, { value: { selection: selection, select: select, deselect: deselect, isWrapped: true } }, children));
};
exports.MultiSelect = MultiSelect;
//# sourceMappingURL=MultiSelect.js.map